module.exports = __webpack_public_path__ + "static/showroom4-2790fa99fd72874e237e628c63643318.jpg";